import React, { Component } from "react";
// import axios from "axios";
import myplexAPI from "../../api/myplexAPI";
import { Link } from "react-router-dom";

// import Img from "../Uicomponents/Img";
import Img from "../../utils/similarContentImg";
// import { slugify } from "../../utils/stringSlugify";
import { slugify } from "../../../commonfiles/stringSlugify";

import { carouselPatnerLogos } from "../../utils/partnerLogos";
import LazyLoad from "react-lazyload";
// import {getURLName} from "../../utils/urlMenu";
import {getURLName} from "../../../commonfiles/urlMenu";

import carousel_freetag from "../../assets/images/freetag_thumbnail.png";
// import carousel_freetag from "../../assets/images/freetag_thumbnail.png";
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/src/owl.carousel.css";
import "react-owl-carousel2/src/owl.theme.default.css";


export default class Episodes extends Component {
  state = {
    contents: [],
    pageName: "Home",
    trackingId :''
  };
  componentDidMount() {
  
    this._getSimilarContent();
    const page_name = window.location.pathname.split("/")[1];
    if (page_name !== "") {
      this.setState({
        pageName: page_name
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.ContentId !== this.props.ContentId) {
      this._getSimilarContent();
    }
  }
  _getSimilarContent() {
    myplexAPI.getSimilarContent(this.props.ContentId).then(response => {
      // console.log(response)
      if (response.data.status === "SUCCESS") {

        this.setState({
          contents: response.data.results,
          trackingId : response.data.trackingId
        });
      }
    });
  }
  _getContent = () =>
  this.state.contents.map((content, i) => {
    // console.log(content)
    let logo = null;
    if (content.publishingHouse !== undefined) {
    let partnerLogos = carouselPatnerLogos(
      content.publishingHouse.publishingHouseName
    );
    if (partnerLogos.link !== undefined) {
      logo = (
      <LazyLoad once>
        <img
        src={partnerLogos.link}
        alt={partnerLogos.name}
        className="you_may_like_logo_patner"
        />
      </LazyLoad>
      );
    }
    }
    return (
    <div >
       <Link
    	to={{
    	  pathname: `/${ getURLName( content, this.state.pageName ) }/detail/${
     		content.generalInfo._id
    	  }/${slugify(content.generalInfo.title)}`
    	  // search: `?videotype=${content.generalInfo.type}`
    	}}
    	key={i}
     >
     <Img
            caroselimg={content}
            key={i}
            banner={false}
           
            observer={true}
          />
    <h4>{content.generalInfo.title}</h4>
    <div className="movie_details-div">
      {/* <ul>
        <li>{content.content.releaseDate}</li>
        <li>{content.content.duration}</li>
      </ul> */}
    </div></Link>
  </div>
    // <div
    //   className="flex-dev"
    //   key={i}
    //   // onClick={() => this.props.setVideoId(content.generalInfo._id)}
    // >
    //   <Link
    // 	to={{
    // 	  pathname: `/${ getURLName( content, this.state.pageName ) }/detail/${
    // 		content.generalInfo._id
    // 	  }/${slugify(content.generalInfo.title)}`
    // 	  // search: `?videotype=${content.generalInfo.type}`
    // 	}}
    // 	key={i}
    //   >
    // 	{!content.generalInfo.isSellable && content.generalInfo.contentRights &&
    // 	content.generalInfo.contentRights[0] === 'avod' && <div className="carousel_freetag">
    // 		<img src={carousel_freetag} alt="carousel_freetag" />
    // 	  </div>}
    // 	<div>
    // 	  <Img caroselimg={content} key={i} />
    // 	  {logo}
    // 	</div>
    // 	<div className="episodes-info">
    // 	  <span> {content.generalInfo.title}</span>
    // 	</div>
    //   </Link>
    // </div>
    );
  });
    // this.state.contents.slice(0, 6).map((content, i) => {
    //   // console.log(content)
    //   let logo = null;
    //   if (content.publishingHouse !== undefined) {
    //     let partnerLogos = carouselPatnerLogos(
    //       content.publishingHouse.publishingHouseName
    //     );
    //     if (partnerLogos.link !== undefined) {
    //       logo = (
    //         <LazyLoad once>
    //           <img
    //             src={partnerLogos.link}
    //             alt={partnerLogos.name}
    //             className="you_may_like_logo_patner"
    //           />
    //         </LazyLoad>
    //       );
    //     }
    //   }
    //   return (
    //     <div
    //       className="flex-dev"
    //       key={i}
    //       // onClick={() => this.props.setVideoId(content.generalInfo._id)}
    //     >
    //       <Link
    //         to={{
    //           pathname: `/${ getURLName( content, this.state.pageName ) }/detail/${
    //             content.generalInfo._id
    //           }/${slugify(content.generalInfo.title)}`
    //           // search: `?videotype=${content.generalInfo.type}`
    //         }}
    //         key={i}
    //       >
    //         {!content.generalInfo.isSellable && content.generalInfo.contentRights &&
    //         content.generalInfo.contentRights[0] === 'avod' && <div className="carousel_freetag">
    //             <img src={carousel_freetag} alt="carousel_freetag" />
    //           </div>}
    //         <div>
    //           <Img caroselimg={content} key={i} />
    //           {logo}
    //         </div>
    //         <div className="episodes-info">
    //           <span> {content.generalInfo.title}</span>
    //         </div>
    //       </Link>
    //     </div>
    //   );
    // });
  sourceDetails = (source_details,trackingId) => {
    // console.log(trackingId)
    // console.log(source_details)
    localStorage.setItem("source details", source_details);
    localStorage.setItem("source", "carousel");
    localStorage.setItem("trackingId",trackingId);
  };
  render() {
    let perpage = 0;

    if (
      this.props.layoutType === "horizontalListBigItem" ||
      this.props.layoutType === "previewCarousel"||
      this.props.layoutType==="roundedArtistCarousel"
    ) {
      perpage = 10;
    } else if (this.props.layoutType === "nestedCarousel") {
      perpage = 8;
    } else {
      perpage = 7;
    }

    const options = {
      items: perpage,

      responsive: {
        320: {
          items: perpage === 10 ? 2 : perpage === 8 ? 4 : 2,
          nav: true,
        },
        360: {
          items: perpage === 10 ? 3 : perpage === 8 ? 4 : 2,
          nav: true,
        },
        481: {
          items: perpage === 10 ? 3 : perpage === 8 ? 4 : 3,
          nav: false,
        },
        768: {
          items: perpage === 10 ? 4 : perpage === 8 ? 5 : 4,
          nav: false,
        },
        1200: {
          items: perpage === 10 ? 6 : perpage === 8 ? 5 : 5,
          nav: true,
        },
        1300: {
          items: perpage === 10 ? 7 : perpage === 8 ? 6 : 7,
          nav: true,
        },
        1400: {
          items: perpage === 10 ? 8 : perpage === 8 ? 6 : 8,
          nav: true,
        },
        1500: {
          items: perpage === 10 ? 8 : perpage === 8 ? 6 : 8,
          nav: true,
        },
        1600: {
          items: perpage === 10 ? 9 : perpage === 8 ? 7 : 8,
          nav: true,
        },
        1700: {
          items: perpage === 10 ? 10 : perpage === 8 ? 7 : 8,
          nav: true,
        },
      },
      nav: true,
      navText: [
        "<div class='carousel-nav-btn carousel-prev-slide'></div>",
        "<div class='carousel-nav-btn carousel-next-slide'></div>",
      ],
      rewind: false,
      margin: 10,
      dots: false,
      autoplay: false,
      slideBy: 10,
      loop: false,
      touchDrag: true,
      mouseDrag: true,
    };

    const events = {
      onDragged: function (event) { },
      onChanged: function (event) { },
    };
    return (
      <div >
        <div className="carousel_body watched_carousel">
      
      <div className="episodes_section">
        	<div className="home_carosel_title">
	
          {this.state.contents.length>0 && <h1>{this.props.you_may_like_title}</h1>}
    {/* <img src={view_all_arrow_mm} className="view_all_arrow" alt="viewall_arrow_img" /> */}
  </div>
        {this.state.contents.length > 0 && (
                  	<OwlCarousel ref="car" options={options} events={events}>
                    {this._getContent()}
                    </OwlCarousel>   )}
        <section>
          {this.state.contents.length > 0 && (
            <div className="you-may-like_section">
       
              {/* {this.state.contents.length > 0 && (
                  
                <div
                  className="flex-container"
                  onClick={() => this.sourceDetails("People also watched",this.state.trackingId)}
                >
                  {this._getContent()}
                </div>
              )} */}
            </div>
          )}
        </section>
      
      </div>
      </div>
      </div>
    );
  }
}
